import React, {useRef} from "react";
import {CheckBoxInput, RadioInput, SelectInput, SliderInput} from "../../../../../Components/Inputs";
import {defaultVirtualPrism, VirtualPrism, defaultAntiSuppression, AntiSuppression, GameSettingsWrapper, SubSettingsWrapper} from "./TemplateGamesSettings"


export const BreakerSettings: React.FC<{
}> = ({}) => {
  const formReference = useRef(null)


  const initialValues = {
    ...defaultVirtualPrism,
    ...defaultAntiSuppression,

    // Game Settings
    "Game Length": 5,
    "Control Mode": "R/L VR",
    "Difficulty": "Easy",
    "Background": "Default",
    "Show Background Elements": true,

    //Unique Anti-Suppression
    "Dichoptic Mode": true,
    "Ball Size": 1
  }

  const difficulty = formReference.current?["values"]["Difficulty"] : ""

  return (
    <GameSettingsWrapper title="Breaker" initialValues={initialValues} formReference={formReference}>
      <VirtualPrism/>
      <AntiSuppression/>
      <SubSettingsWrapper title="Unique Anti-Suppression">
        <CheckBoxInput name="Dichoptic Mode"/>
        <SliderInput name="Ball Size" min={0.1} max={3} step={0.1}/>
        {difficulty === "Custom" ? (<>
          <SliderInput name="Ball Opacity" min={25} max={100} step={1}/>
          <SliderInput name="Powerup Opacity" min={25} max={100} step={1}/>
        </>) : undefined}
      </SubSettingsWrapper>
      <SubSettingsWrapper title="Game Settings">
        <SliderInput name="Game Length" min={1} max={30} step={1} decimalPlaces={0} unit="m"/>
        <RadioInput name="Control Mode" options={["R/L VR", "Gamepad"]}/>
        <SelectInput name="Difficulty" options={["Easy", "Medium", "Hard", "Master", "Custom"]}/>
        {difficulty === "Custom" ? (<>
          <SliderInput name="Starting Level" min={1} max={20} step={1} decimalPlaces={0}/>
          <SliderInput name="Ball Speed" min={1} max={10} step={0.1}/>
          <SliderInput name="Maximum Ball Count" min={2} max={8} step={1} decimalPlaces={0}/>
        </>) : undefined}
        <RadioInput name="Background" options={["Default", "R", "O", "Y", "G", "B", "I", "V", "BK"]}/>
        <CheckBoxInput name="Show Background Elements"/>
      </SubSettingsWrapper>
    </GameSettingsWrapper>
  )
}


export const games = {
  "Breaker": {
    setting: <BreakerSettings/>,
    color: "#F2BB2D"
  },
  "Bubbles": {
    setting: <BreakerSettings/>,
    color: "#2BA84E"
  },
  "Stereo": {
    setting: <BreakerSettings/>,
    color: "#226888"
  },
  "Bullseye": {
    setting: <BreakerSettings/>,
    color: "#226888"
  },
  "Hoopie": {
    setting: <BreakerSettings/>,
    color: "#226888"
  },
  "Pepper Picker": {
    setting: <BreakerSettings/>,
    color: "#226888"
  },
  "Ring Runner": {
    setting: <BreakerSettings/>,
    color: "#226888"
  },

}
export type GameName = keyof typeof games
